import React from 'react';
import ModalTextInput from './components/ModalTextInput';
import SuggestionsWrapper from './components/SuggestionsWrapper';
import SuggestionsList from './components/SuggestionsList';
import { TrendingSuggestions } from './components/TrendingSuggestions';

const Suggestions = ({
    anchorRef,
    isModal,
    isTrendingVisible,
}: {
    anchorRef: React.RefObject<HTMLDivElement>;
    isModal: boolean;
    isTrendingVisible: boolean;
}) => (
    <SuggestionsWrapper anchorRef={anchorRef} isModal={isModal}>
        <>
            {isModal && <ModalTextInput />}
            <SuggestionsList />
            {isTrendingVisible && <TrendingSuggestions />}
        </>
    </SuggestionsWrapper>
);

export default Suggestions;
